import React from 'react'

const Manual_cargar_imagenes_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Cargar imágenes Ecommerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo subir y gestionar imágenes de productos para tu tienda online desde Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Cargar_imagenes_Ecommerce__6Z3AABsHSnC2xGpQLjSfuQ?as=scrollable"
          className="scribe-iframe-general-104"
          width="100%"
          height="2500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cargar_imagenes_ecommerce
